
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select";

interface HotelFiltersProps {
  countries: string[];
  cities: string[];
  selectedCountry: string;
  selectedCity: string;
  onCountryChange: (country: string) => void;
  onCityChange: (city: string) => void;
}

export const HotelFilters = ({ countries, cities, selectedCountry, selectedCity, onCountryChange, onCityChange }: HotelFiltersProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      <div>
        <Label htmlFor="country-select">الدولة</Label>
        <Select value={selectedCountry} onValueChange={onCountryChange}>
          <SelectTrigger id="country-select"><SelectValue placeholder="اختر دولة" /></SelectTrigger>
          <SelectContent><SelectGroup><SelectLabel>الدول</SelectLabel>{countries.map(c => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectGroup></SelectContent>
        </Select>
      </div>
      <div>
        <Label htmlFor="city-select">المدينة</Label>
        <Select value={selectedCity} onValueChange={onCityChange} disabled={!selectedCountry}>
          <SelectTrigger id="city-select"><SelectValue placeholder="اختر مدينة" /></SelectTrigger>
          <SelectContent><SelectGroup><SelectLabel>المدن</SelectLabel>{cities.map(c => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectGroup></SelectContent>
        </Select>
      </div>
    </div>
  );
};
